import { EuiCheckbox, EuiFlexGroup, EuiFlexItem } from '@elastic/eui';
import { isEmpty } from 'lodash';
import React, { useCallback, useEffect, useState } from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { useSelector } from 'react-redux';

const ApplyOrderingModes = () => {
    const { control, watch, setValue } = useFormContext();
    const restaurantOrderingModes = useSelector((state) => state.restaurantReducer.orderingModes);

    const itemOrderingModes = useWatch({
        control,
        name: 'ordering_modes',
    });
    const [orderingModeState, setOrderingModeState] = useState([]);
    const [removedOrderingModes, setRemovedOrderingModes] = useState([]);

    useEffect(() => {
        if (itemOrderingModes?.length) {
            setOrderingModeState(itemOrderingModes);
        }
    }, [itemOrderingModes, watch]);

    const updateOrderingMode = useCallback(
        (mode, event) => {
            let selectedMode = {
                restaurant_ordering_mode_id: mode?.id,
                restaurant_ordering_mode_name: mode?.display_name,
            };

            const isChecked = event.target.checked;

            if (!isChecked) {
                // removed ordering mode
                const doesModeExisted = restaurantOrderingModes?.filter(
                    (res_mode) => res_mode.id === selectedMode.restaurant_ordering_mode_id
                )?.[0];
                if (!isEmpty(doesModeExisted)) {
                    setRemovedOrderingModes([...removedOrderingModes, doesModeExisted?.id]);
                    const updatedOrderingMode = orderingModeState.filter(
                        (mode) => mode.restaurant_ordering_mode_id !== selectedMode.restaurant_ordering_mode_id
                    );
                    if (updatedOrderingMode.length) {
                        setOrderingModeState(updatedOrderingMode);
                        setValue(`ordering_modes`, updatedOrderingMode);
                    }
                    setValue(`delete_ordering_modes`, [...removedOrderingModes, doesModeExisted?.id]);
                } else {
                    const removedFromOrderingState = orderingModeState.filter(
                        (mode) => mode.restaurant_ordering_mode_id !== selectedMode.restaurant_ordering_mode_id
                    );
                    setOrderingModeState(removedFromOrderingState);
                    setValue(`ordering_modes`, removedFromOrderingState);
                }
            } else {
                setOrderingModeState((prevState) => [...prevState, selectedMode]);

                // check if the id is in removeState
                const destroyFromRemoveState = removedOrderingModes?.filter(
                    (id) => id != selectedMode.restaurant_ordering_mode_id
                );
                setRemovedOrderingModes(destroyFromRemoveState);
                setValue(`delete_ordering_modes`, destroyFromRemoveState);
                setValue(`ordering_modes`, [...orderingModeState, selectedMode]);
            }
        },
        [orderingModeState, removedOrderingModes, restaurantOrderingModes, setValue]
    );

    return (
        <EuiFlexGroup alignItems='center' style={{ padding: '10px' }} justifyContent='flexStart' wrap responsive>
            {restaurantOrderingModes
                ?.filter((orderingMode) => orderingMode.status)
                .map((mode) => {
                    return (
                        <React.Fragment key={mode.id.toString()}>
                            <EuiFlexItem>
                                <EuiFlexGroup direction='row' justifyContent='flexStart' alignItems='flexEnd'>
                                    <EuiFlexItem grow={false}>
                                        <Controller
                                            render={({ field }) => (
                                                <EuiCheckbox
                                                    onChange={(e) => {
                                                        field.onChange(e.target.checked);
                                                        updateOrderingMode(mode, e);
                                                        setValue(`${mode.display_name}_${mode.id}`, e.target.checked);
                                                    }}
                                                    id={`${mode.display_name}_${mode.id}`}
                                                    checked={Boolean(field.value)}
                                                    compressed
                                                />
                                            )}
                                            name={`${mode.display_name}_${mode.id}`}
                                            control={control}
                                        />
                                    </EuiFlexItem>
                                    <EuiFlexItem grow={false}>
                                        <label
                                            htmlFor={`${mode.display_name}_${mode.id}`}
                                            style={{ cursor: 'pointer', textTransform: 'capitalize' }}
                                        >
                                            {mode.display_name}
                                        </label>
                                    </EuiFlexItem>
                                </EuiFlexGroup>
                            </EuiFlexItem>
                        </React.Fragment>
                    );
                })}
        </EuiFlexGroup>
    );
};

export default React.memo(ApplyOrderingModes);
